import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useI18n } from '@/hooks/useI18n';
import { useToast } from '@/hooks/useToast';
import { accessRequestApi } from '@/lib/api/endpoints';
import { routes } from '@/lib/routes';
import { AuthCard } from './components/AuthCard';

const VerifyAccessEmailPage = () => {
  const { t } = useI18n();
  const { notify } = useToast();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const requestId = params.get('request')?.trim() ?? '';
  const token = params.get('token')?.trim() ?? '';
  const [status, setStatus] = useState<'ready' | 'loading' | 'ok' | 'error'>('ready');

  useEffect(() => {
    if (!requestId || !token) setStatus('error');
  }, [requestId, token]);

  const confirm = async () => {
    if (!requestId || !token) {
      setStatus('error');
      return;
    }
    setStatus('loading');
    try {
      await accessRequestApi.confirmVerification(requestId, token);
      setStatus('ok');
      localStorage.setItem('za_access_request_id', requestId);
      notify(t('auth.verify.confirmed'), 'success');
    } catch {
      setStatus('error');
      notify(t('auth.verify.invalid'), 'error');
    }
  };

  return (
    <AuthCard title={t('auth.verify.title')} showTabs={false}>
      {status === 'ready' && (
        <>
          <p>{t('auth.verify.ready')}</p>
          <button type="button" className="auth-primary" onClick={() => void confirm()}>
            {t('auth.verify.confirm')}
          </button>
        </>
      )}
      {status === 'loading' && <p>{t('common.loading')}</p>}
      {status === 'ok' && (
        <>
          <p>{t('auth.verify.confirmed')}</p>
          <button
            type="button"
            className="auth-primary"
            onClick={() =>
              navigate(
                requestId
                  ? `${routes.requestAccess}?request=${encodeURIComponent(requestId)}`
                  : routes.requestAccess,
              )
            }
          >
            {t('auth.verify.back')}
          </button>
        </>
      )}
      {status === 'error' && (
        <>
          <p>{t('auth.verify.invalid')}</p>
          <button type="button" className="auth-link" onClick={() => navigate(routes.login)}>
            {t('auth.backToLogin')}
          </button>
        </>
      )}
    </AuthCard>
  );
};

export default VerifyAccessEmailPage;
